import CHARACTER_DATA from '../data/characterData.js';

const createCharacterInput = (id) => {
  if (!Object.keys(CHARACTER_DATA).includes(id)) return null;
  return {
    id: id,
    ascension: {
      current: 0,
      target: 0,
    },
    level: {
      current: 1,
      target: 1,
    },
    attack: {
      current: 1,
      target: 1,
    },
    skill: {
      current: 1,
      target: 1,
    },
    burst: {
      current: 1,
      target: 1,
    },
  };
}

export default createCharacterInput;
